function Header1Mobile({ children }: any) {
  return (
    <div className="text-custom-white tracking-[0.020em] font-semibold text-[23px] mb-6 mt-8">
      {children}
    </div>
  );
}

export default Header1Mobile;


